import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import { animateScroll as scroll } from "react-scroll";
import { observer } from "mobx-react";
import whiteLogoUrl from "../assets/images/reaktivate_logo_white.svg";
import originalLogoUrl from "../assets/images/reaktivate_logo_original.svg";

@observer
class Header extends Component {
  scrollToTop = () => {
    scroll.scrollToTop({
      containerId: "containerElement"
    });
  };
  
  
//          <Link to={"/"} className="logo" onClick={this.scrollToTop}>
//          <img src={this.props.white ? whiteLogoUrl : originalLogoUrl} alt="Home" />
//        </Link>

  
  render() {
    const { projects } = this.props;

    return (
      <div className="header">
        <a href={"/"} className="logo">
          <img src={this.props.white ? whiteLogoUrl : originalLogoUrl} alt="Home" />
        </a>
        <div className="hidden-image-preloader" style={{ display: "none" }}>
          {projects.map( object => (
            <img src={object.mainImage} key={object.slug} alt={object.title} />
          ))}
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js